import { Component, Prop, Vue } from 'vue-property-decorator';

type Size = 'small' | 'medium' | 'large';
type Type = 'primary' | 'secondary' | 'transparent';
type Display = 'inline' | 'block';
type AvailableClasses = {
    'button_secondary'?: boolean;
    'button_transparent'?: boolean;
    'button_small'?: boolean;
    'button_large'?: boolean;
    'button_two-strings'?: boolean;
    'button_three-strings'?: boolean;
    'button_disabled'?: boolean;
    'button_centered'?: boolean;
    'button_block'?: boolean;
    'button_no-wrap-text'?: boolean;
}

@Component
export default class extends Vue {
    @Prop(String) readonly upperText?: string;

    @Prop(String) readonly bottomText?: string;

    @Prop(Boolean) readonly disabled?: boolean;

    @Prop(Boolean) readonly centered?: boolean;

    @Prop({ default: 'medium' }) readonly size!: Size;

    @Prop({ default: 'primary' }) readonly type!: Type;

    @Prop({ default: false }) readonly enabledNoWrapText!: boolean

    @Prop({ default: 'inline' }) readonly display!: Display;

    get classes(): AvailableClasses {
        const classes: AvailableClasses = {};

        // {'button_two-strings': hasTwoStrings, 'button_three-strings': hasThreeStrings}
        if (this.upperText && this.bottomText) {
            classes['button_three-strings'] = true;
        } else if (this.upperText || this.bottomText) {
            classes['button_two-strings'] = true;
        }

        if (this.size === 'large') {
            classes.button_large = true;
        } else if (this.size === 'small') {
            classes.button_small = true;
        }

        if (this.type === 'secondary') {
            classes.button_secondary = true;
        } else if (this.type === 'transparent') {
            classes.button_transparent = true;
        }

        if (this.disabled) {
            classes.button_disabled = true;
        }

        if (this.centered) {
            classes.button_centered = true;
        }

        if (this.display === 'block') {
            classes.button_block = true;
        }

        if (this.enabledNoWrapText) {
            classes['button_no-wrap-text'] = true;
        }

        return classes;
    }

    buttonClick(event: Event): void {
        if (!this.disabled) {
            this.$emit('click', event);
        }
    }
}